import React from 'react'
import Tatalogo from "../../assets/landingPageImg/tatamotors.png"
import deeplogo from "../../assets/landingPageImg/deeplogo.jpg"

const Landingpageheader = () => {
    return (
        <div className=' w-full mt-5 flex justify-between p-1'>
            <img src={deeplogo} alt="Tata Motors" className="hidden md:block w-24 " />
            <img src={Tatalogo} alt="Tata Motors" className="hidden md:block w-32 h-8 pr-2 " />



        </div>
    )
}

export default Landingpageheader
